import actionTypes from '../../utilities/actionTypes';
export interface IFetchPlaylists {
  type: actionTypes.FETCH_PLAYLISTS;
  resetFilters?: boolean;
}
export interface IFetchPlaylistsPending {
  type: actionTypes.FETCH_PLAYLISTS_PENDING;
}
export interface IFetchPlaylistsSuccess {
  type: actionTypes.FETCH_PLAYLISTS_SUCCESS;
  payload: any;
}
export interface IFetchPlaylistsReject {
  type: actionTypes.FETCH_PLAYLISTS_REJECT;
}
export interface ISelectPlaylist {
  type: actionTypes.SELECT_PLAYLIST;
  playlistId: string; // feedcode+customer+date
}
export interface IDeSelectPlaylist {
  type: actionTypes.DESELECT_PLAYLIST;
}
export interface IResetPlaylistFetchCount {
  type: actionTypes.RESET_PLAYLIST_FETCH_COUNT;
}
export interface IEscalatePlaylist {
  type: actionTypes.ESCALATE_PLAYLIST;
  payload: any;
}
export interface ISnoozePlaylist {
  type: actionTypes.SNOOZE_PLAYLIST;
  payload: any;
}
export interface IResolvePlaylist {
  type: actionTypes.RESOLVE_PLAYLIST;
  payload: any;
}
export const fetchPlaylists = (resetFilters?: boolean): IFetchPlaylists => {
  return {
    type: actionTypes.FETCH_PLAYLISTS,
    resetFilters
  };
};
export const fetchPlaylistsPending = (): IFetchPlaylistsPending => {
  return {
    type: actionTypes.FETCH_PLAYLISTS_PENDING
  };
};
export const fetchPlaylistsSuccess = (payload): IFetchPlaylistsSuccess => {
  return {
    type: actionTypes.FETCH_PLAYLISTS_SUCCESS,
    payload
  };
};

export const fetchPlaylistsReject = (): IFetchPlaylistsReject => {
  return {
    type: actionTypes.FETCH_PLAYLISTS_REJECT
  };
};
export const selectPlaylist = (playlistId: string): ISelectPlaylist => {
  return {
    type: actionTypes.SELECT_PLAYLIST,
    playlistId
  };
};
export const deselectPlaylist = (): IDeSelectPlaylist => {
  return {
    type: actionTypes.DESELECT_PLAYLIST
  };
};
export const resetPlaylistFetchCount = (): IResetPlaylistFetchCount => {
  return {
    type: actionTypes.RESET_PLAYLIST_FETCH_COUNT
  };
};

export const escalatePlaylist = (payload: any): IEscalatePlaylist => {
  return {
    type: actionTypes.ESCALATE_PLAYLIST,
    payload
  };
};
export const resolvePlaylist = (payload: any): IResolvePlaylist => {
  return {
    type: actionTypes.RESOLVE_PLAYLIST,
    payload
  };
};
export const snoozePlaylist = (payload: any): ISnoozePlaylist => {
  return {
    type: actionTypes.SNOOZE_PLAYLIST,
    payload
  };
};
export type IPlaylistActions =
  | IFetchPlaylists
  | IFetchPlaylistsPending
  | IFetchPlaylistsSuccess
  | IFetchPlaylistsReject
  | ISelectPlaylist
  | IDeSelectPlaylist
  | IResetPlaylistFetchCount
  | IEscalatePlaylist
  | ISnoozePlaylist
  | IResolvePlaylist;
